import { Component } from '@angular/core'
import { ContentLayoutComponent } from '../../content-layout.component'
import { Button } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';

@Component({
    selector: 'app-side-bar-notifications',
    templateUrl: './side-bar-notifications.component.html',
    styleUrls: ['./side-bar-notifications.component.scss'],
    standalone: true,
    imports: [
        Button,
        DividerModule,
        MessagesModule,
    ],
})
export class SidebarNotificationsComponent {
  constructor(public contentLayout: ContentLayoutComponent) {}
}
